export enum ViewModeEnum {
  Dashboard = 'dashboard',
  Grid = 'grid',
  Split = 'split',
//   Full = 'full',
  Schedule = 'schedule',
  Attendance = 'attendance',
  AttendanceStats = 'attendance-stats',
  Insights = 'insights',
  Report = 'report',
  Documents = 'documents'
}

export type ViewMode = ViewModeEnum;

export const VIEW_MODES: ViewMode[] = [
  ViewModeEnum.Grid,
  ViewModeEnum.Split,
//   ViewModeEnum.Full,
  ViewModeEnum.Report,
];
